// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3gmEK","left":"styles_left__3ctr5","desktopActions":"styles_desktopActions__2tmU-","title":"styles_title__3ThXJ"};